import React from 'react';
import Avatar from './Avatar';
import StarRating from './StarRating';
import PillBadge from './PillBadge';
import { formatHybridDate } from '../utils/date';

function statusBadge(review, fallbackMode) {
  if (fallbackMode) return null;
  const s = review?.reply_status;
  if (s === 'published') return <PillBadge label="Publié" variant="success" />;
  if (s === 'ignored') return <PillBadge label="Ignoré" variant="default" />;
  // null + pending → "À répondre"
  return <PillBadge label="À répondre" variant="info" />;
}

export default function ReviewCard({ review, onTap, fallbackMode = false }) {
  const handleClick = () => {
    if ('vibrate' in navigator) navigator.vibrate(5);
    if (typeof onTap === 'function') onTap(review);
  };

  return (
    <button type="button" onClick={handleClick} style={styles.card} aria-label={`Avis de ${review.author_name || 'anonyme'}`}>
      <Avatar name={review.author_name} photoUrl={review.profile_photo_url} size={40} />

      <div style={styles.body}>
        <div style={styles.headerRow}>
          <span style={styles.name}>{review.author_name || 'Anonyme'}</span>
          {statusBadge(review, fallbackMode)}
        </div>
        <div style={styles.metaRow}>
          <StarRating rating={review.rating} size={13} />
          <span style={styles.date}>{formatHybridDate(review.review_time)}</span>
        </div>
        {review.text && (
          <p style={styles.verbatim}>{review.text}</p>
        )}
      </div>
    </button>
  );
}

const styles = {
  card: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    padding: '14px 16px',
    background: '#FFFFFF',
    border: 'none',
    borderBottom: '1px solid #EDEAE3',
    width: '100%',
    textAlign: 'left',
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  body: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    minWidth: 0,
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
  },
  name: {
    fontSize: 14,
    fontWeight: 700,
    color: '#1A1A1A',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  metaRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  date: {
    fontSize: 12,
    color: '#6B6B6B',
  },
  verbatim: {
    margin: '4px 0 0',
    fontSize: 14,
    color: '#1A1A1A',
    lineHeight: 1.45,
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};
